/**
 * Web app entrypoint. Wraps the router in ClerkProvider and React's StrictMode.
 *
 * `VITE_CLERK_PUBLISHABLE_KEY` is required at build time. If unset, we
 * fall back to the hardcoded development key for this Clerk instance — that
 * key is intentionally public (Clerk's design) and only works against the
 * `musical-hound-88.clerk.accounts.dev` Development environment.
 */

import { ClerkProvider } from '@clerk/clerk-react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import './styles.css';

const PUBLISHABLE_KEY =
  import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ??
  'pk_test_bXVzaWNhbC1ob3VuZC04OC5jbGVyay5hY2NvdW50cy5kZXYk';

if (!PUBLISHABLE_KEY) {
  throw new Error('Missing Clerk publishable key');
}

const root = document.getElementById('root');
if (!root) throw new Error('#root element not found in index.html');

createRoot(root).render(
  <StrictMode>
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="/">
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ClerkProvider>
  </StrictMode>,
);
